@if (show) {
<ngx-skeleton-loader
  count="1"
  appearance="line"
  [theme]="{
        height: '40px',
        margin: '0',
        borderRadius: '0',
      }"
/>
}
